import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=70c211a2"
var script = {}
import style0 from "./Card.vue?vue&type=style&index=0&id=70c211a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports